var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6133_3103)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.39 15.69C31.39 24.36 24.36 31.39 15.69 31.39C7.02 31.39 0 24.37 0 15.69C0 7.01 7.02 0 15.69 0C24.36 0 31.39 7.03 31.39 15.69Z",
    fill: "#FFDF00"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.74 12.0599C18.1 10.2899 22.34 10.4799 23.4 12.5699C23.96 13.6699 24.18 14.8399 24.2 16.0399C24.25 18.5499 24.21 21.0699 24.23 23.5799C24.23 24.0299 24.12 24.2199 23.64 24.1999C22.73 24.1699 21.82 24.1699 20.9 24.1999C20.38 24.2199 20.26 23.9999 20.26 23.5299C20.27 21.2599 20.23 18.9899 20.28 16.7199C20.31 15.1999 19.43 14.6499 17.98 14.8499C17.19 14.9599 16.74 15.5799 16.74 16.4899C16.74 18.7799 16.72 21.0699 16.74 23.3599C16.74 23.9899 16.58 24.2299 15.92 24.1899C15.08 24.1399 14.23 24.1599 13.38 24.1899C12.94 24.1999 12.75 24.0899 12.75 23.5999C12.77 19.5499 12.77 15.4999 12.75 11.4499C12.75 10.9599 12.94 10.8399 13.38 10.8599C14.22 10.8799 15.07 10.9099 15.92 10.8599C16.58 10.8199 16.82 11.0599 16.72 11.6899C16.7 11.7899 16.72 11.8899 16.72 12.0599H16.74Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.12 17.5297C11.12 19.4897 11.1 21.4397 11.13 23.3997C11.13 23.9797 11.01 24.2497 10.35 24.2097C9.49002 24.1497 8.62002 24.1797 7.75002 24.2097C7.34002 24.2097 7.15002 24.1297 7.15002 23.6597C7.16002 19.5897 7.16002 15.5197 7.15002 11.4497C7.15002 11.0097 7.30002 10.8597 7.73002 10.8797C8.64002 10.8997 9.55002 10.9097 10.46 10.8797C10.96 10.8597 11.12 11.0497 11.12 11.5397C11.1 13.5397 11.12 15.5397 11.12 17.5397V17.5297Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16002 8.15954C7.16002 7.07954 8.01002 6.19954 9.08002 6.18954C10.19 6.17954 11.1 7.06954 11.1 8.15954C11.1 9.16954 10.12 10.1295 9.11002 10.1295C8.05002 10.1295 7.16002 9.22954 7.15002 8.15954H7.16002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6133_3103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.39,
    height: 31.39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.6d999ab1eec6e79581590f47ec63e887.svg";
export { ForwardRef as ReactComponent };